export const getBookings = (state) => state.myCars.bookings;
export const getStatusFilter = (state) => state.myCars.statusFilter;
export const getCurrentPage = (state) => state.myCars.currentPage;
export const getVehicles = (state) => state.myCars.vehicles;
export const getCounts = (state) => state.myCars.counts;
export const getLoading = (state) => state.myCars.loading;
export const getPageLoading = (state) => state.myCars.pageLoading;
